import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { createSAL2030_R01RowKey, defaultSAL2030_R01Dto, parseSAL2030_R01Amt, SAL2030_R01Dto } from './Dto_SAL2030_R01';

export interface SAL2030_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	customCd: string;
	customNm: string;
	itemCd: string;
	itemNm: string;
	refetchListLength?: number;
}

export interface Store_SAL2030_R01 {
	SAL2030_R01Filter: SAL2030_R01Filter;
	SAL2030_R01PastFilter: SAL2030_R01Filter;
	setSAL2030_R01Filter: (filter: Partial<Store_SAL2030_R01['SAL2030_R01Filter']>) => void;
	setSAL2030_R01PastFilter: (filter: Store_SAL2030_R01['SAL2030_R01PastFilter']) => void;

	// ====== 매출 내역 리스트 ======
	SAL2030_R01List: SAL2030_R01Dto[];
	setSAL2030_R01List: (list: SAL2030_R01Dto[]) => void;

	selectedSAL2030_R01: SAL2030_R01Dto | undefined;
	setSelectedSAL2030_R01: (data: SAL2030_R01Dto | undefined) => void;
	initSelectedSAL2030_R01: () => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	allCount: number;
	setAllCount: (allCount: number) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	pdfUrl: string | null;
	pdfBlob: Blob | null;
	setPdf: (blob: Blob | null) => void;

	// ====== 초기화 ======
	initData: () => void;
}

export const defaultSAL2030_R01Filter: SAL2030_R01Filter = {
	compCd: '',
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	customCd: '',
	customNm: '',
	itemCd: '',
	itemNm: ''
};

export const useSAL2030_R01Store = create<Store_SAL2030_R01>((set) => ({
	SAL2030_R01Filter: defaultSAL2030_R01Filter,
	SAL2030_R01PastFilter: defaultSAL2030_R01Filter,
	setSAL2030_R01Filter: (update) => set((state) => ({
		SAL2030_R01Filter: {
			...state.SAL2030_R01Filter,
			...update
		}
	})),
	setSAL2030_R01PastFilter: (filter: Store_SAL2030_R01['SAL2030_R01PastFilter']) => set((state) => {
		return {
			...state,
			SAL2030_R01PastFilter: filter
		}
	}),

	// ====== 매출 내역 리스트 ======
	SAL2030_R01List: [],
	setSAL2030_R01List: (list: SAL2030_R01Dto[]) => set((state) => {
		const newList = list.map((item, index) => ({
			...item,
			valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
			orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
			orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0,
			rowKey: createSAL2030_R01RowKey(item.compCd, item.salesDt),
			salesAmt: parseSAL2030_R01Amt(item.salesAmt),
		}));
		
		return {
			...state,
			SAL2030_R01List: newList
		};
	}),

	selectedSAL2030_R01: undefined,
	setSelectedSAL2030_R01: (data: SAL2030_R01Dto | undefined) => set({
		selectedSAL2030_R01: data,
	}),
	initSelectedSAL2030_R01: () => set({
		selectedSAL2030_R01: undefined,
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	pdfUrl: null,
	pdfBlob: null,
	setPdf: (blob: Blob | null) => set((state) => {
		if (state.pdfUrl) {
			URL.revokeObjectURL(state.pdfUrl);
		}
		if (!blob) {
			return { pdfUrl: null, pdfBlob: null };
		}
		return {
			pdfUrl: URL.createObjectURL(blob),
			pdfBlob: blob,
		};
	}),

	// ====== 초기화 ======
	initData: () => set((state) => {
		if (state.pdfUrl) {
			URL.revokeObjectURL(state.pdfUrl);
		}
		return {
			...state,
			SAL2030_R01Filter: defaultSAL2030_R01Filter,
			SAL2030_R01PastFilter: defaultSAL2030_R01Filter,
			SAL2030_R01List: [],
			selectedSAL2030_R01: undefined,
			allCount: 0,
			columnState: null,
			scrollTop: null,
			pdfUrl: null,
			pdfBlob: null,
		};
	}),
}));

